import { create } from 'zustand';
import { useSpeedAnalysisStore } from './speedAnalysisStore';
import { useDeviceStore } from './deviceStore';

interface PitchAnalysisState {
  startFrame: number | null;
  endFrame: number | null;
  steps: number;
  fps: number;
  setStartFrame: (frame: number) => void;
  setEndFrame: (frame: number) => void;
  setSteps: (steps: number) => void;
  setFps: (fps: number) => void;
  reset: () => void;
  calculateResults: () => {
    frameCount: number;
    pitch: number;
    stride: number;
  } | null;
}

export const usePitchAnalysisStore = create<PitchAnalysisState>((set, get) => ({
  startFrame: null,
  endFrame: null,
  steps: 4,
  fps: useSpeedAnalysisStore.getState().fps,
  setStartFrame: (frame) => set({ startFrame: frame }),
  setEndFrame: (frame) => set({ endFrame: frame }),
  setSteps: (steps) => set({ steps }),
  setFps: (fps) => set({ fps }),
  reset: () => set({ startFrame: null, endFrame: null }),
  calculateResults: () => {
    const { startFrame, endFrame, steps, fps } = get();
    if (startFrame === null || endFrame === null) return null;

    const deviceType = useDeviceStore.getState().deviceType;
    
    // iPhoneの場合は4で割って補正、PCの場合はそのまま
    const frameCount = Math.abs(endFrame - startFrame) / (deviceType === 'iphone' ? 4 : 1);
    
    const time = frameCount / fps;
    const basePitch = steps / time;
    const pitch = basePitch * 2; // Double the pitch

    const speedResults = useSpeedAnalysisStore.getState().calculateResults();
    const speed = speedResults?.speed ?? 0;
    const baseStride = speed / basePitch;
    const stride = baseStride / 2; // Halve the stride

    return {
      frameCount,
      pitch,
      stride,
    };
  },
}));